import { WaterDisposalSystemBase } from './base/water-disposal-system-base';

export class WaterDisposalSystem extends WaterDisposalSystemBase { }